import { render, staticRenderFns } from "./personnel-bankinfo-list.vue?vue&type=template&id=0c0718b2&scoped=true&"
import script from "./personnel-bankinfo-list.vue?vue&type=script&lang=js&"
export * from "./personnel-bankinfo-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0718b2",
  null
  
)

export default component.exports